import React from 'react';

export default function ConfirmDialog({ message, onConfirm, onCancel, dangerous }) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content max-w-sm" onClick={e => e.stopPropagation()}>
        <div className="px-6 py-5">
          <div className="flex items-start gap-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${dangerous ? 'bg-red-100' : 'bg-amber-100'}`}>
              <svg className={`w-5 h-5 ${dangerous ? 'text-red-600' : 'text-amber-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div>
              <h3 className="text-base font-semibold text-surface-900 mb-1">Confirm Delete</h3>
              <p className="text-sm text-surface-600">{message}</p>
              <p className="text-xs text-surface-400 mt-1">This action cannot be undone.</p>
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-6">
            <button onClick={onCancel} className="btn-secondary">No, Cancel</button>
            <button onClick={onConfirm} className="btn-danger">Yes, Delete</button>
          </div>
        </div>
      </div>
    </div>
  );
}
